import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ManageFileService } from 'src/app/shared/services/manage-files/manage-files.service';
import { finalize } from 'rxjs/operators';

type PreviewData = { id: string; name: string; kind: 'image' | 'video' };

@Component({
  selector: 'app-manage-file-preview-dialog',
  templateUrl: './manage-file-preview-dialog.component.html',
  styleUrls: ['./manage-file-preview-dialog.component.scss']
})
export class ManageFilePreviewDialogComponent implements OnInit, OnDestroy {
  loading = true;
  safeUrl: SafeResourceUrl | null = null;
  private objectUrl: string | null = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PreviewData,
    private dialogRef: MatDialogRef<ManageFilePreviewDialogComponent>,
    private files: ManageFileService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.files.getFileThumbnail(this.data.id, false)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: (blob) => {
          this.objectUrl = URL.createObjectURL(blob);
          this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
        },
        error: () => this.dialogRef.close()
      });
  }

  ngOnDestroy(): void {
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
      this.objectUrl = null;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}